/**
 * White Label Branding Configuration
 *
 * This file centralizes all branding elements to support white labeling.
 * Modify this file to rebrand the application.
 */

const brandingConfig = {
  // Basic Information
  appName: "Taxiruf Kempten",
  companyName: "Taxiruf Zentrale Kempten",

  // Contact Information
  email: "info@taxiruf-kempten.de",
  phone: "+49 (0) 831 – 575 339 34",
  address: "Tiefenbacher Str. 9, 87437 Kempten (Allgäu)",
  owner: "Zia Ullah Khan", // Inhaber/Geschäftsführer (Pflicht für Impressum gemäß TMG § 5)
  website: "https://taxiruf-kempten.de", // Website-URL

  // Supervisory Authority (Aufsichtsbehörde für Personenbeförderung)
  // Kempten (Allgäu) ist eine kreisfreie Stadt – zuständig ist die Stadtverwaltung.
  // TODO: Genaue Abteilung/Adresse beim Ordnungsamt der Stadt Kempten verifizieren.
  supervisoryAuthority: {
    name: "Stadt Kempten (Allgäu)",
    department: "Ordnungsamt – Personenbeförderung",
    address: "Rathausplatz 22, 87435 Kempten (Allgäu)",
  },

  // Data Protection Authority (Datenschutz-Aufsichtsbehörde)
  // Bayern – nicht-öffentliche Stellen: Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)
  dataProtectionAuthority: {
    name: "Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)",
    address: "Promenade 18, 91522 Ansbach",
    phone: "+49 981 180093-0",
    website: "https://www.lda.bayern.de",
  },

  // Legal Information
  copyright: `© ${new Date().getFullYear()} Taxiruf Zentrale Kempten`,

  // Colors
  colors: {
    primary: "#FFD600", // Taxi Yellow
    secondary: "#000000", // Black
    accent: "#FFA000", // Amber
    success: "#388E3C", // Green
    error: "#D32F2F", // Red
    warning: "#FF9800", // Orange
    info: "#2196F3", // Blue
    background: "#FFFFFF", // White
    text: {
      primary: "#333333", // Near Black
      secondary: "#757575", // Medium Gray
      light: "#FFFFFF", // White
    }
  },

  // Logos and Images
  logos: {
    primary: "/assets/TaxirufKempten_Logo.png", // Full logo
    icon: "/assets/TaxirufKempten_Icon.png", // Icon only
    favicon: "/favicon.ico",
    mobileLogo: "/assets/TaxirufKempten_Icon.png",
  },

  // UI Elements
  ui: {
    borderRadius: "4px",
    buttonStyle: "rounded", // 'rounded', 'square', 'pill'
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },

  // Features Config
  features: {
    enableReports: true,
    enableLiveMap: true,
    enableShiftPlanning: true,
  },

  // Social Media
  socialMedia: {
    facebook: "",
    twitter: "",
    instagram: "",
  },
};

export default brandingConfig;
